import {
  Button,
  Typography,
  useTheme,
  Link,
  Box
} from '@mui/material'
import React from 'react'
import { useUser } from '../redux/slices/user/useUser'

type Props = {
  onCancel: () => Promise<void>
  onResendVerificationEmail: () => void
  onCheckEmailVerification: () => void
}

const VerifyEmailComponent = (props: Props) => {
  const { onCancel, onResendVerificationEmail, onCheckEmailVerification } = props;
  const theme = useTheme()
  const { lyfshortUser } = useUser();

  return (
    <div>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          color: theme.palette.grey[800],
          fontWeight: 500,
          mb: 3
        }}
      >
        Verify Your Email Address
      </Typography>
      <Typography textAlign="center" my={2}>A verification email has been sent to:</Typography>
      <Box textAlign="center">
        <Link>{lyfshortUser?.email}</Link>
      </Box>
      <Typography textAlign="center" my={2}>Open this email and follow the link to finish completing your profile and then press</Typography>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        size="large"
        sx={{
          mt: 3,
          mb: 2,
          height: 48,
          backgroundColor: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        }}
        onClick={onCheckEmailVerification}
      >
        Continue
      </Button>
      <Typography textAlign="center" my={2}>Haven't received a verification email yet? Check your junk folder or</Typography>
      <Button
        fullWidth
        variant="contained"
        color="inherit"
        sx={{
          mt: 3,
          mb: 2,
          height: 48,
          backgroundColor: theme.palette.grey[100],
        }}
        onClick={onResendVerificationEmail}
      >
        Re-send verification email
      </Button>
      <Box textAlign="center">
        <Link
          component="button"
          sx={{
            cursor: 'pointer',
          }}
          onClick={onCancel}
        >
          Cancel
        </Link>
      </Box>
    </div>
  )
}

export default VerifyEmailComponent